/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sample: NonNullable<unknown> }} Measure_Latency_Estimate_SampleInputs */

const en_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Response time estimate (${i?.sample} across endpoints)`)
};

const zh_hans1_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`响应时间估算（${i?.sample}，跨接口汇总）`)
};

const pt_br2_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estimativa do tempo de resposta (${i?.sample} entre endpoints)`)
};

const es_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estimación del tiempo de respuesta (${i?.sample} entre endpoints)`)
};

const fr_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estimation du temps de réponse (${i?.sample} sur l’ensemble des endpoints)`)
};

const de_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geschätzte Antwortzeit (${i?.sample} über alle Endpoints)`)
};

const ru_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Оценка времени ответа (${i?.sample} по эндпоинтам)`)
};

const it_measure_latency_estimate_sample = /** @type {(inputs: Measure_Latency_Estimate_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stima del tempo di risposta (${i?.sample} su tutti gli endpoint)`)
};

/**
* | output |
* | --- |
* | "Response time estimate ({sample} across endpoints)" |
*
* @param {Measure_Latency_Estimate_SampleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_estimate_sample = /** @type {((inputs: Measure_Latency_Estimate_SampleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_Estimate_SampleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_estimate_sample(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_estimate_sample(inputs)
	if (locale === "es") return es_measure_latency_estimate_sample(inputs)
	if (locale === "fr") return fr_measure_latency_estimate_sample(inputs)
	if (locale === "de") return de_measure_latency_estimate_sample(inputs)
	if (locale === "ru") return ru_measure_latency_estimate_sample(inputs)
	if (locale === "it") return it_measure_latency_estimate_sample(inputs)
	return en_measure_latency_estimate_sample(inputs)
});